// extracted by mini-css-extract-plugin
export default {"container":"AddEmployee_container__fdCV6","infor":"AddEmployee_infor__K7eLm","price":"AddEmployee_price__SK1BH","sideDishes":"AddEmployee_sideDishes__jh2-e"};